// StaffNotice.js - Final Version (Exactly like Notice.js)
import React, { useContext, useEffect, useRef, useState } from "react";
import { Container, Modal, Button, Spinner } from "react-bootstrap";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";
import axios from "axios";
import moment from "moment";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { renderPdfToImages } from "../utils/pdfPrint";
import { useSearchParams } from "react-router-dom";

const DESCRIPTION_PREVIEW_LENGTH = 150;
const URL_REGEX = /((?:https?:\/\/|www\.)[^\s<]+)/gi;

// Split a matched URL into the link itself and trailing punctuation
const splitTrailing = (part) => {
  const match = part.match(/^(.*?)([.,!?;:)\]'"]*)$/);
  return match ? [match[1], match[2]] : [part, ""];
};

// Returns the Google Drive file id for drive.google.com file links, else null
const getDriveFileId = (url) => {
  if (!url || !/drive\.google\.com/i.test(url)) return null;
  const pathMatch = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (pathMatch) return pathMatch[1];
  const queryMatch = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
  return queryMatch ? queryMatch[1] : null;
};

// If the direct video stream hasn't started by then, fall back to Drive's preview player
const DRIVE_VIDEO_TIMEOUT_MS = 15000;

const DrivePlayer = ({ fileId }) => {
  // "video": direct HTML5 stream with our own play/pause; "iframe": Drive preview fallback
  const [mode, setMode] = useState("video");
  const [loading, setLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    setMode("video");
    setLoading(true);
    setIsPlaying(false);
  }, [fileId]);

  // Stream never became playable (large file, not a video, blocked) -> use Drive preview
  useEffect(() => {
    if (mode !== "video" || !loading) return undefined;
    const timer = setTimeout(() => setMode("iframe"), DRIVE_VIDEO_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [mode, loading, fileId]);

  const fallbackToIframe = () => {
    setLoading(true);
    setIsPlaying(false);
    setMode("iframe");
  };

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  };

  return (
    <div className="drive-player-wrap">
      <div className={`drive-player ${mode === "video" ? "is-video" : "is-iframe"}`}>
        {loading && (
          <div className="drive-player-loading">
            <Spinner animation="border" variant="light" />
            <p className="small mt-2 mb-0">Loading video...</p>
          </div>
        )}
        {mode === "video" ? (
          <>
            <video
              key={`video-${fileId}`}
              ref={videoRef}
              src={`https://drive.google.com/uc?export=download&id=${fileId}`}
              controls
              controlsList="nodownload"
              playsInline
              preload="metadata"
              onLoadedData={() => setLoading(false)}
              onCanPlay={() => setLoading(false)}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={() => setIsPlaying(false)}
              onError={fallbackToIframe}
            />
            {!loading && !isPlaying && (
              <button
                type="button"
                className="drive-center-play"
                onClick={togglePlay}
                aria-label="Play video"
              >
                <i className="ti ti-player-play-filled"></i>
              </button>
            )}
          </>
        ) : (
          <>
            <iframe
              key={`iframe-${fileId}`}
              src={`https://drive.google.com/file/d/${fileId}/preview`}
              title="Google Drive Preview"
              allow="autoplay; fullscreen"
              allowFullScreen
              onLoad={() => setLoading(false)}
            />
            {/* Covers Drive's pop-out button so the video can't be opened in a new tab */}
            <div className="drive-popout-blocker" />
          </>
        )}
      </div>
      {mode === "video" && !loading && (
        <div className="d-flex justify-content-center mt-3">
          <button
            type="button"
            className="btn btn-primary d-flex align-items-center gap-2 fw-semibold px-4"
            onClick={togglePlay}
          >
            <i className={`ti ${isPlaying ? "ti-player-pause" : "ti-player-play"}`}></i>
            {isPlaying ? "Pause" : "Play"}
          </button>
        </div>
      )}
    </div>
  );
};

// Render text with URLs converted to clickable links.
// Google Drive links call onDriveClick (if given) instead of opening a new tab.
const linkifyText = (text, onDriveClick) => {
  if (!text) return null;
  return String(text).split(URL_REGEX).map((part, index) => {
    if (index % 2 === 0) return part;
    const [url, trailing] = splitTrailing(part);
    const href = url.toLowerCase().startsWith("www.") ? `https://${url}` : url;
    const driveId = getDriveFileId(url);
    return (
      <React.Fragment key={index}>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="notice-link"
          onClick={(e) => {
            e.stopPropagation();
            if (driveId && onDriveClick) {
              e.preventDefault();
              onDriveClick(driveId);
            }
          }}
        >
          {driveId && <i className="ti ti-player-play me-1"></i>}
          {url}
        </a>
        {trailing}
      </React.Fragment>
    );
  });
};

const NoticePage = () => {
  const [notices, setNotices] = useState([]);
  const [filteredNotices, setFilteredNotices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const authtoken = localStorage.getItem("token");
  const { GetstudentData } = useContext(ProductContext);
  const [searchParams] = useSearchParams();
  const notifiableType = searchParams.get("notifiable_type");
  const notifiableId = searchParams.get("notifiable_id");

  console.log(notifiableType, "notifiableType Data1");
  console.log(notifiableId, "notifiableId Data1");
  

  

  const classSectionId = GetstudentData?.class_section_id;

  // Modal States
  const [showModal, setShowModal] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [zoomScale, setZoomScale] = useState(1);
  const [rotationDegrees, setRotationDegrees] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [expandedNotices, setExpandedNotices] = useState({});

  const toggleExpanded = (id) => {
    setExpandedNotices((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // Drive video playing in its own modal
  const [videoDriveId, setVideoDriveId] = useState(null);
  // Reopen the notice modal after the video closes if the video was opened from it
  const [returnToNoticeModal, setReturnToNoticeModal] = useState(false);

  const openVideoModal = (driveId, fromNoticeModal = false) => {
    setReturnToNoticeModal(fromNoticeModal);
    if (fromNoticeModal) setShowModal(false);
    setVideoDriveId(driveId);
  };

  const closeVideoModal = () => {
    setVideoDriveId(null);
    if (returnToNoticeModal) {
      setShowModal(true);
      setReturnToNoticeModal(false);
    }
  };

  // Time ago function
  const timeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInMs = now - past;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInDays < 30) return `${diffInDays}d ago`;
    return past.toLocaleDateString("en-GB");
  };

  // Open Modal with full notice details
  const openNoticeModal = (notice) => {
    setSelectedNotice(notice);
    setZoomScale(1);
    setRotationDegrees(0);
    setFileLoading(Boolean(notice?.file_upload));
    setShowModal(true);
  };

  const getFileType = (url) => {
    if (!url) return "";
    try {
      const cleanUrl = url.split("?")[0].toLowerCase();
      if (cleanUrl.endsWith(".pdf")) return "pdf";

      const docExtensions = [".docx", ".doc", ".xlsx", ".xls", ".pptx", ".ppt", ".zip", ".rar", ".txt", ".csv"];
      if (docExtensions.some(ext => cleanUrl.endsWith(ext))) {
        return "other";
      }

      return "image";
    } catch (e) {
      console.error(e);
    }
    return "image";
  };

  const printFile = async (url) => {
    if (!url || printing) return;

    if (window.ReactNativeWebView) {
      setPrinting(true);
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: "PRINT_FILE", url, filename: selectedNotice?.notice_heading }));
      setTimeout(() => setPrinting(false), 1500);
      return;
    }

    setPrinting(true);

    const cleanUrl = url.split("?")[0].toLowerCase();
    const isPdf = cleanUrl.endsWith(".pdf");

    const oldIframe = document.getElementById("noticePrintIframe");
    if (oldIframe) oldIframe.remove();

    const iframe = document.createElement("iframe");
    iframe.id = "noticePrintIframe";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.style.zIndex = "-9999";
    document.body.appendChild(iframe);

    try {
      let imageHtml = "";
      if (isPdf) {
        try {
          const pageImages = await renderPdfToImages(url);
          imageHtml = pageImages.map(src => `<img src="${src}" class="pdfPrintPage" />`).join("");
        } catch (pdfErr) {
          console.warn("PDF render for print failed:", pdfErr);
          imageHtml = `<iframe src="${url}" style="width:100%;height:100vh;border:none;"></iframe>`;
        }
      } else {
        let printSrc = url;
        try {
          const res = await fetch(url);
          if (res.ok) {
            const blob = await res.blob();
            printSrc = window.URL.createObjectURL(blob);
          }
        } catch (e) {
          console.warn("Fetch blob failed for print image:", e);
        }
        imageHtml = `<img src="${printSrc}" class="pdfPrintPage" />`;
      }

      const docHtml = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>Print Notice</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style>
              body { margin: 0; padding: 0; background: #ffffff; text-align: center; }
              .pdfPrintPage { max-width: 100%; height: auto; display: block; margin: 0 auto 10px auto; page-break-after: always; }
              .pdfPrintPage:last-child { page-break-after: auto; }
              @media print {
                body { margin: 0; padding: 0; }
                .pdfPrintPage { max-width: 100%; width: 100%; height: auto; page-break-after: always; }
                .pdfPrintPage:last-child { page-break-after: auto; }
              }
            </style>
          </head>
          <body>
            ${imageHtml}
          </body>
        </html>
      `;

      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(docHtml);
      iframeDoc.close();

      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          console.error("Iframe print error:", e);
        }
        setPrinting(false);
        setTimeout(() => iframe.remove(), 2000);
      }, 500);
    } catch (err) {
      console.error("Print error:", err);
      iframe.remove();
      setPrinting(false);
    }
  };


  const downloadFile = async (url, filename) => {
    if (!url) return;
    setDownloading(true);
    try {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "DOWNLOAD_FILE", url, filename }));
        setTimeout(() => setDownloading(false), 1500);
        return;
      }

      const cleanUrl = url.split("?")[0].toLowerCase();
      let ext = ".jpg";
      if (cleanUrl.endsWith(".pdf")) ext = ".pdf";
      else if (cleanUrl.endsWith(".png")) ext = ".png";
      else if (cleanUrl.endsWith(".jpg") || cleanUrl.endsWith(".jpeg")) ext = ".jpg";
      else if (cleanUrl.endsWith(".gif")) ext = ".gif";
      else if (cleanUrl.endsWith(".webp")) ext = ".webp";
      else if (cleanUrl.endsWith(".docx")) ext = ".docx";
      else if (cleanUrl.endsWith(".xlsx")) ext = ".xlsx";

      const name = (filename || "notice-attachment").replace(/[^a-zA-Z0-9-_]/g, "_") + ext;

      // Method 1: Fetch as blob
      try {
        const response = await fetch(url);
        if (response.ok) {
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = name;
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          }, 1000);
          setDownloading(false);
          return;
        }
      } catch (fetchErr) {
        console.warn("Fetch blob download failed, trying canvas/direct download...", fetchErr);
      }

      // Method 2: Canvas DataURL download for images
      const isImage = [".png", ".jpg", ".jpeg", ".gif", ".webp"].some(e => cleanUrl.endsWith(e));
      if (isImage) {
        try {
          const dataUrl = await new Promise((resolve) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => {
              try {
                const canvas = document.createElement("canvas");
                canvas.width = img.naturalWidth || img.width;
                canvas.height = img.naturalHeight || img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL(ext === ".png" ? "image/png" : "image/jpeg", 0.95));
              } catch (e) { resolve(null); }
            };
            img.onerror = () => resolve(null);
            img.src = url;
          });

          if (dataUrl) {
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => document.body.removeChild(link), 1000);
            setDownloading(false);
            return;
          }
        } catch (canvasErr) {
          console.warn("Canvas download failed", canvasErr);
        }
      }

      // Method 3: Direct link click
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 1000);

    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setDownloading(false);
    }
  };




  useEffect(() => {
    if (classSectionId) {
      const cacheKey = `notices_${classSectionId}`;
      const cached = getCachedData(cacheKey);
      if (cached) {
        setNotices(cached);
        setFilteredNotices(cached);
        setLoading(false);
      }
      if (!cached) setLoading(true);
      axios
        .get(
          `https://api.mirai.healthcare/api/head/notice/classSection/${classSectionId}`,
          {
            headers: { "x-auth": authtoken },
          }
        )
        .then((response) => {
          const noticesData = response?.data?.data || [];
          const sortedNotices = [...noticesData].sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          setNotices(sortedNotices);
          setFilteredNotices(sortedNotices);
          setCachedData(cacheKey, sortedNotices);
        })
        .catch((error) => {
          console.error("Error fetching notices:", error);
        })
        .finally(() => setLoading(false));
    }
  }, [classSectionId]);

  // Paginated Data
  const paginatedNotices = filteredNotices.slice(0, page * pageSize);
  const hasMore = filteredNotices.length > paginatedNotices.length;

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleFilter = () => {
    let filtered = [...notices];

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter((notice) =>
        (notice.notice_heading || "").toLowerCase().includes(q) ||
        (notice.description || "").toLowerCase().includes(q)
      );
    }

    if (fromDate && toDate) {
      filtered = filtered.filter((notice) => {
        const noticeDate = new Date(notice.date).toISOString().split("T")[0];
        return noticeDate >= fromDate && noticeDate <= toDate;
      });
    }

    if (fromDate && !toDate) {
      filtered = filtered.filter(
        (n) => new Date(n.date) >= new Date(fromDate)
      );
    }

    if (!fromDate && toDate) {
      filtered = filtered.filter(
        (n) => new Date(n.date) <= new Date(toDate)
      );
    }

    setFilteredNotices(filtered);
    setPage(1);
  };

  const handleReset = () => {
    setSearchQuery("");
    setFromDate("");
    setToDate("");
    setFilteredNotices(notices);
    setPage(1);
  };

  useEffect(() => {
  if (notifiableId && paginatedNotices.length > 0) {
    setTimeout(() => {
      const element = document.getElementById(`notice-${notifiableId}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 500); // Small delay to ensure DOM is rendered
  }
}, [notifiableId, paginatedNotices]);

  return (
    <div className="page-wrapper min-vh-100">
      <Header />

      <div className="content px-4 pt-5">
        {/* Page Header */}
        <div className="text-center mb-4">
          <h2 className="page-title fw-bold mb-0">
            <i className="ti ti-bell-ringing me-2 text-primary"></i>
            School Notices
          </h2>
          <p className="text-muted">Latest announcements from administration</p>
        </div>
        <div className="row g-3 mb-4">
          <div className="col-md-3">
            <label className="form-label text-secondary fw-semibold fs-12 mb-1">Search Notice</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search heading or description..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label text-secondary fw-semibold fs-12 mb-1">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label text-secondary fw-semibold fs-12 mb-1">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="col-md-3 d-flex align-items-end gap-2">
            <button
              className="btn btn-primary w-50"
              onClick={handleFilter}
            >
              Apply Filter
            </button>

            <button
              className="btn btn-secondary w-50"
              onClick={handleReset}
            >
              Reset
            </button>
          </div>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white border-0 pb-0">
            <h4 className="mb-0">
              <i className="ti ti-timeline me-2 text-primary"></i>
              Notice Timeline
            </h4>
          </div>

          <div className="card-body py-4">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : notices?.length === 0 ? (
              <div className="text-center py-5">
                <i className="ti ti-bell-off text-muted display-1"></i>
                <h5 className="mt-3 text-muted">No Notices Available</h5>
                <p>Check back later for updates from the school.</p>
              </div>
            ) : (
              <>
                <div className="timeline position-relative">
                  {paginatedNotices.map((notice) => {
  const isHighlighted = Number(notifiableId) === Number(notice.id);

  return (
    <div 
      key={notice.id} 
      id={`notice-${notice.id}`}
      className="timeline-item mb-5"
    >
      <div className={`timeline-dot rounded-circle ${isHighlighted ? "bg-warning" : "bg-primary"}`}>
        <i className="ti ti-bell text-white"></i>
      </div>

      <div 
        className={`timeline-content card shadow-sm p-4 border-0 hover-lift transition-all ${
          isHighlighted ? "border border-3 border-warning bg-light-warning shadow-lg" : ""
        }`}
        style={
          isHighlighted 
            ? { 
                backgroundColor: "#fff9e6", 
                borderLeft: "5px solid #ffc107", 
                boxShadow: "0 4px 12px rgba(255, 193, 7, 0.3)" 
              } 
            : {}
        }
      >
        <div className="d-flex justify-content-between align-items-start mb-2">
          <h5 className="mb-0 text-primary">
            <i className="ti ti-megaphone me-2"></i>
            {notice.notice_heading}
            {isHighlighted && (
              <span className="badge bg-warning text-white ms-2 fs-12">
                Highlighted Notice
              </span>
            )}
          </h5>
          <span className="badge bg-success-soft text-success">
            Approved
          </span>
        </div>

        {(() => {
          const description = notice.description || "";
          const isLong =
            description.length > DESCRIPTION_PREVIEW_LENGTH ||
            description.split("\n").length > 2;
          const isExpanded = !!expandedNotices[notice.id];
          return (
            <div className="mb-3">
              <p
                className={`text-muted mb-1 notice-description ${
                  isLong && !isExpanded ? "line-clamp-2" : ""
                }`}
              >
                {linkifyText(description, (driveId) => openVideoModal(driveId))}
              </p>
              {isLong && (
                <button
                  type="button"
                  className="btn btn-link p-0 fs-13 fw-semibold text-primary text-decoration-none"
                  onClick={() => toggleExpanded(notice.id)}
                >
                  {isExpanded ? "Read less" : "Read more"}
                  <i className={`ti ${isExpanded ? "ti-chevron-up" : "ti-chevron-down"} ms-1`}></i>
                </button>
              )}
            </div>
          );
        })()}

        <div className="row g-3 text-muted small NewBorderTop">
          <div className="col-md-4">
            <p className="mb-2 fs-14 text-black">
              <i className="ti ti-calendar-event text-primary me-2"></i>
              <strong>Date:</strong>{" "}
              {new Date(notice.date).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>
          <div className="col-md-4">
            <p className="mb-2 fs-14 text-black">
              <i className="ti ti-clock text-primary me-2"></i>
              <strong>Posted:</strong>{" "}
              {notice.created_at
                ? moment(notice.created_at).format("DD MMM YYYY, hh:mm A")
                : timeAgo(notice.created_at)}
            </p>
          </div>
          <div className="col-md-4 text-md-end">
            {notice.file_upload && (
              <span className="badge bg-info-soft text-info me-2">
                <i className="ti ti-paperclip me-1"></i>
                Attachment
              </span>
            )}
          </div>
        </div>

        <div className="mt-3 text-end">
          <button
            onClick={() => openNoticeModal(notice)}
            className={`btn btn-sm ${isHighlighted ? "btn-warning text-white" : "btn-outline-primary"}`}
          >
            <i className="ti ti-eye me-2"></i>
            View Notice
          </button>
        </div>
      </div>
    </div>
  );
})}
                </div>

                {/* Load More Button */}
                {hasMore && (
                  <div className="text-center mt-5">
                    <button
                      onClick={() => setPage(page + 1)}
                      className="btn btn-primary px-4"
                    >
                      <i className="ti ti-chevron-down me-2"></i>
                      Load More Notices
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Full Notice & Attachment Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-primary fw-bold fs-16">
            <i className="ti ti-megaphone me-2"></i>
            {selectedNotice?.notice_heading || "School Notice"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          {selectedNotice?.file_upload && getFileType(selectedNotice.file_upload) === "image" && (
            <div className="d-flex justify-content-center gap-2 mb-3 bg-light p-2 rounded border border-light">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setZoomScale(prev => Math.max(0.2, prev - 0.1))}
                title="Zoom Out"
                className="d-flex align-items-center justify-content-center"
                style={{ width: "32px", height: "32px", borderRadius: "6px" }}
              >
                <i className="ti ti-zoom-out fs-14" />
              </Button>
              <span className="d-flex align-items-center justify-content-center fw-semibold text-secondary px-2" style={{ fontSize: "13px", minWidth: "55px" }}>
                {Math.round(zoomScale * 100)}%
              </span>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setZoomScale(prev => Math.min(3, prev + 0.1))}
                title="Zoom In"
                className="d-flex align-items-center justify-content-center"
                style={{ width: "32px", height: "32px", borderRadius: "6px" }}
              >
                <i className="ti ti-zoom-in fs-14" />
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setZoomScale(1)}
                title="Reset Zoom"
                className="d-flex align-items-center justify-content-center ms-2"
                style={{ width: "32px", height: "32px", borderRadius: "6px" }}
              >
                <i className="ti ti-refresh fs-14" />
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setRotationDegrees(prev => (prev + 90) % 360)}
                title="Rotate"
                className="d-flex align-items-center justify-content-center ms-1"
                style={{ width: "32px", height: "32px", borderRadius: "6px" }}
              >
                <i className="ti ti-rotate-clockwise fs-14" />
              </Button>
            </div>
          )}

          {selectedNotice?.file_upload && (
            <div
              className="d-flex align-items-center justify-content-center bg-light rounded position-relative mb-3"
              style={{
                minHeight: "350px",
                height: "55vh",
                overflow: "auto",
                border: "1px dashed #cbd5e1"
              }}
            >
              {fileLoading && (
                <div className="position-absolute top-50 start-50 translate-middle text-center" style={{ zIndex: 15 }}>
                  <Spinner animation="border" variant="primary" />
                  <p className="text-muted small mt-2 mb-0 fw-medium">Loading document...</p>
                </div>
              )}
              {getFileType(selectedNotice.file_upload) === "pdf" ? (
                <div className="position-relative w-100 h-100 overflow-hidden">
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "48px",
                      height: "48px",
                      backgroundColor: "#ffffff",
                      zIndex: 10,
                      pointerEvents: "auto"
                    }}
                  />
                  <iframe
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedNotice.file_upload)}&embedded=true`}
                    className="w-100 h-100 rounded"
                    style={{ border: "none" }}
                    title="Notice PDF Preview"
                    onLoad={() => setFileLoading(false)}
                  />
                </div>
              ) : getFileType(selectedNotice.file_upload) === "image" ? (


                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    minWidth: "100%",
                    minHeight: "100%",
                    padding: "20px",
                    overflow: "auto"
                  }}
                >
                  <img
                    src={selectedNotice.file_upload}
                    alt="Notice Attachment"
                    className="img-fluid rounded"
                    onLoad={() => setFileLoading(false)}
                    onError={() => setFileLoading(false)}
                    style={{
                      maxHeight: "100%",
                      transform: `scale(${zoomScale}) rotate(${rotationDegrees}deg)`,
                      transformOrigin: "center center",
                      transition: "transform 0.2s ease-in-out",
                      objectFit: "contain"
                    }}
                  />
                </div>
              ) : (
                <div className="text-center p-4">
                  <i className="ti ti-file-text text-muted mb-3" style={{ fontSize: "64px" }} />
                  <p className="text-secondary fw-medium mb-1">Preview not available for this file type</p>
                  <p className="text-muted small mb-0">Please download the file using the button below to view it.</p>
                </div>
              )}
            </div>
          )}

          <div className="bg-light p-4 rounded">
            <h6 className="text-primary mb-2">
              <i className="ti ti-info-circle me-2"></i>
              Notice Details
            </h6>

            <div className="row g-3 text-muted small NewBorderTop">
              <div className="col-6 fs-14 text-black">
                <strong>Date:</strong>{" "}
                {selectedNotice?.date
                  ? new Date(selectedNotice.date).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })
                  : "N/A"}
              </div>
              <div className="col-6 fs-14 text-black">
                <strong>Posted:</strong>{" "}
                {selectedNotice?.created_at ? moment(selectedNotice.created_at).format("DD MMM YYYY, hh:mm A") : timeAgo(selectedNotice?.created_at)}
              </div>
            </div>
            <p className="mt-3 pt-2 NewBorderTop notice-description">
              {linkifyText(selectedNotice?.description, (driveId) => openVideoModal(driveId, true))}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setShowModal(false)}
            style={{ borderRadius: "8px", fontWeight: "600" }}
          >
            Close
          </Button>
          {selectedNotice?.file_upload && (
            getFileType(selectedNotice.file_upload) === "pdf" ? (
              <Button
                variant="primary"
                disabled={downloading}
                onClick={() => downloadFile(selectedNotice.file_upload, selectedNotice.notice_heading)}
                className="d-flex align-items-center gap-2 px-4"
                style={{ borderRadius: "8px", fontWeight: "600" }}
              >
                {downloading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" /> Downloading...
                  </>
                ) : (
                  <>
                    <i className="ti ti-download" /> Download Attachment
                  </>
                )}
              </Button>
            ) : (
              <Button
                variant="primary"
                disabled={printing}
                onClick={() => printFile(selectedNotice.file_upload)}
                className="d-flex align-items-center gap-2 px-4"
                style={{ borderRadius: "8px", fontWeight: "600" }}
              >
                {printing ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" /> Preparing...
                  </>
                ) : (
                  <>
                    <i className="ti ti-printer" /> Print
                  </>
                )}
              </Button>
            )
          )}
        </Modal.Footer>


      </Modal>

      {/* Google Drive Video Modal (full screen on mobile) */}
      <Modal
        show={Boolean(videoDriveId)}
        onHide={closeVideoModal}
        size="lg"
        centered
        fullscreen="sm-down"
        contentClassName="drive-video-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-primary fw-bold fs-16">
            <i className="ti ti-player-play me-2"></i>
            Video
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 d-flex flex-column justify-content-center">
          {videoDriveId && <DrivePlayer fileId={videoDriveId} />}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={closeVideoModal}
            style={{ borderRadius: "8px", fontWeight: "600" }}
          >
            <i className="ti ti-x me-1" /> Close Video
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Same Timeline Styling as Notice.js */}
      <style jsx>{`
        .timeline {
          padding-left: 40px;
        }
        .timeline::before {
          content: "";
          position: absolute;
          left: 20px;
          top: 0;
          bottom: 0;
          width: 3px;
          background: linear-gradient(to bottom, #4361ee, #3f37c9);
          border-radius: 2px;
        }
        .timeline-item {
          position: relative;
        }
        .timeline-dot {
          position: absolute;
          left: -40px;
          top: 15px;
          width: 40px;
          height: 40px;
          background: #4361ee;
          border: 5px solid #fff;
          box-shadow: 0 0 0 4px #e0e7ff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
        .timeline-content {
          border-radius: 12px;
          transition: all 0.3s ease;
        }
        .hover-lift:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 35px rgba(67, 97, 238, 0.15) !important;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .notice-description {
          white-space: pre-line;
          word-break: break-word;
        }
        .notice-link {
          color: #4361ee;
          text-decoration: underline;
          word-break: break-all;
        }
        .notice-link:hover {
          color: #3f37c9;
        }
        .drive-player {
          position: relative;
          width: 100%;
          border-radius: 10px;
          overflow: hidden;
          background: #000;
        }
        /* Direct video: sized by the video's own aspect ratio, so nothing is cropped */
        .drive-player.is-video {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 220px;
        }
        .drive-player.is-video video {
          display: block;
          width: 100%;
          height: auto;
          max-height: 70vh;
          object-fit: contain;
          background: #000;
        }
        /* Drive preview fallback: fixed 16:9 box (works without aspect-ratio support) */
        .drive-player.is-iframe {
          height: 0;
          padding-top: 56.25%;
        }
        .drive-center-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
          width: 64px;
          height: 64px;
          border: 0;
          border-radius: 50%;
          background: rgba(67, 97, 238, 0.9);
          color: #fff;
          font-size: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
        }
        .drive-player-wrap {
          width: 100%;
        }
        .drive-player iframe {
          position: absolute;
          inset: 0;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }
        .drive-player-loading {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #fff;
          background: #000;
        }
        .drive-popout-blocker {
          position: absolute;
          top: 0;
          right: 0;
          width: 64px;
          height: 64px;
          z-index: 3;
          background: #000;
        }
        @media (max-width: 576px) {
          .timeline {
            padding-left: 28px;
          }
          .timeline::before {
            left: 12px;
          }
          .timeline-dot {
            left: -32px;
            width: 32px;
            height: 32px;
            border-width: 3px;
          }
          .timeline-content.p-4 {
            padding: 14px !important;
          }
          .drive-player {
            border-radius: 8px;
          }
          .drive-player.is-video video {
            max-height: calc(100vh - 220px);
          }
          .drive-player.is-iframe {
            height: calc(100vh - 170px);
            padding-top: 0;
          }
          .drive-center-play {
            width: 52px;
            height: 52px;
            font-size: 22px;
          }
          .drive-popout-blocker {
            width: 52px;
            height: 52px;
          }
          .hover-lift:hover {
            transform: none;
          }
        }
        .bg-success-soft {
          background-color: rgba(34, 197, 94, 0.1) !important;
          color: #22c55e !important;
        }
        .bg-info-soft {
          background-color: rgba(59, 130, 246, 0.1) !important;
          color: #3b82f6 !important;
        }
      `}</style>
    </div>
  );
};

export default NoticePage;
